// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1FuRU","title":"ClientReferral_title__Z6zK6","itemText":"ClientReferral_itemText__1s4Jc"};